(function () {
  function waitForImages(track) {
    var images = Array.from(track.querySelectorAll('img'));

    if (!images.length) {
      return Promise.resolve();
    }

    return Promise.all(
      images.map(function (image) {
        if (image.complete) {
          return Promise.resolve();
        }

        return new Promise(function (resolve) {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      })
    );
  }

  function prepareTrack(track) {
    if (track.dataset.wfAsSeenInReady === 'true') {
      return;
    }

    Promise.race([
      waitForImages(track),
      new Promise(function (resolve) {
        window.setTimeout(resolve, 1500);
      }),
    ]).then(function () {
      track.dataset.wfAsSeenInReady = 'true';
      track.classList.add('is-ready');
    });
  }

  function init() {
    document.querySelectorAll('[data-wf-as-seen-in-track]').forEach(prepareTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
